import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';
import { LicensesEffects } from './effects';
import { licensesReducer } from './reducer';

@NgModule({
  imports: [StoreModule.forFeature(StoreTypes.Licenses, licensesReducer), EffectsModule.forFeature([LicensesEffects])]
})
export class LicensesStoreModule {}
